import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  type PaymentHistorySortOrder,
  type StudentPaymentHistoryDateField,
} from '~entities/student/api/get-student-payment-history';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';
import { normalizePaymentRows } from '~shared/helpers/normalize-payments';

import { type PaymentHistory } from '../model/payment.type';

export interface GetParentPaymentHistoryParams {
  parentId: string;
  startDate: string;
  endDate: string;
  /** Which date the range filters and sorts by; backend defaults to due date when omitted */
  dateField?: StudentPaymentHistoryDateField;
  /** API default is descending when omitted */
  sortOrder?: PaymentHistorySortOrder;
}

export const getParentPaymentHistory = async ({
  parentId,
  ...params
}: GetParentPaymentHistoryParams) => {
  const response = await baseAPI.get<Array<PaymentHistory>>(
    `/subscription-invoices/payment-history/parent/${parentId}`,
    {
      params,
    },
  );
  return normalizePaymentRows(response.data);
};

export const useGetParentPaymentHistory = (
  params: GetParentPaymentHistoryParams,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.PARENT_PAYMENTS_HISTORY(params),
    queryFn: () => getParentPaymentHistory(params),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
